module.exports = {
  name: 'hidden', base: '_field', prototype: {
    element_selector: 'input[type=hidden]'
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/hidden.js
 ** module id = 20
 ** module chunks = 0
 **/